/**
 * WordPress dependencies
 */
import { store, getElement } from '@wordpress/interactivity';

const { state } = store('klx-sticky-header', {
    state: {
        isHidden: false,
        lastScroll: 0,
        headerHeight: 0,
    },
    actions: {
        toggleHide: () => {
            const headerElement = getElement().ref;
            state.headerHeight = `${headerElement.clientHeight}px`;
            
            const currentScroll = window.scrollY;

            if (currentScroll > 100) {
                if (currentScroll < state.lastScroll) {
                    state.isHidden = false;
                } else {
                    state.isHidden = true;
                }
            } else {
                state.isHidden = false;
            }

            state.lastScroll = currentScroll;
        },
    },
});

